<template>
  <div class="body">
    <el-link type="primary" class="title" :underline='false'>基础信息</el-link>
    <el-form ref="added" :model="formData" :rules="rules" size="medium" label-position="right" label-width="120px">
     <el-form-item label="招聘名称：" prop="name">
        <el-input style="width: 400px;" v-model="formData.name" placeholder="请输入招聘名称" :maxlength='30' show-word-limit></el-input>
      </el-form-item>
      
      <el-form-item label="薪 资：">
        <el-input v-if="formData.salary_unit != 0" style="width: 200px;margin-right: 15px;" v-model="formData.salary" placeholder="请输入薪资" type="text" :maxlength='10' show-word-limit></el-input>
        <el-select v-model="formData.salary_unit" placeholder="请选择" style="width: 90px;">
          <el-option label="面议" :value="0"></el-option>
          <el-option label="元/天" :value="1"></el-option>
          <el-option label="元/月" :value="2"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="招聘地点：" prop="address">
        <el-input style="width: 400px;" type="text" show-word-limit :maxlength="50"
          @input="formData.address=formData.address.length > 50?formData.address.slice(0, 50):formData.address"
          v-model="formData.address" placeholder="请输入招聘地点">
        </el-input>
      </el-form-item>
 
      <el-form-item label="招聘描述：" prop="description" label-width="120px">
        <Editor width='880px' scene_name='activity' v-model='formData.description'></Editor>
      </el-form-item>
    </el-form>
    <el-link type="primary" class="title" :underline='false'>招聘配置信息</el-link>
    <Form ref='form' @change="save" :canEdit='!$route.query.id'></Form>
  </div>
</template>

<script>
  import userInfoAPI from '@/api/api';
  import { upload } from '@/api/upload';
  import Editor from '@/components/Editor';
  import Form from './Form.vue';
  export default {
    name: 'userManage',
    components: {
      Editor,
      Form
    },
    data() {
      var validate_enroll_number_people = function(rule, value, callback) {
        if (value === 0 || (value && value < 1)) {
          callback(new Error('报名限制人数不能小于1'))
        } else {
          callback()
        }
      }
      return {
        formData: { //弹窗 内容
          name: '',
          salary: '',
          salary_unit: 0,
          description: '',
          address: '',
          delivery_config_info: []
        },
        rules: { //弹窗 正则
          name: [{
            required: true,
            message: '请输入招聘名称',  
            trigger: 'blur'
          }],
          description: [{
            required: true,
            message: '请输入描述',
            trigger: 'blur'
          }]
        },
        loading: true
      }
    },
    created() {
      if(this.$route.query.id){
        this.getDetail()
      }
    },
    methods: {
      getDetail() {
        userInfoAPI.getRecruitDetail(this.$route.query.id).then(({
          data
        }) => {
          if (data.code == 0) {
            this.formData = data.data
            this.$refs.form.formList = [...this.$refs.form.formList,...data.data.recruitment_config] 
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
          this.loading = false
        })
      },
      save(formList){
        this.$refs['added'].validate(async valid => {
          if (valid) {
            if(this.$route.query.id){
              await userInfoAPI.updateRecruit(this.$route.query.id, {
               name: this.formData.name,
               salary: this.formData.salary,
               salary_unit: this.formData.salary_unit,
               description: this.formData.description,
               address: this.formData.address
              }).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  })
                  this.$router.back()
                } else {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  })
                }
              })
            }else{
              this.formData.delivery_config_info = formList
              await userInfoAPI.addRecruit(this.formData).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  })
                  this.formData =
                   {
                    name: '',
                    salary: '',
                    salary_unit: '0',
                    description: '',
                    address: '',
                    delivery_config_info: []
                  }
                  this.$router.back()
                } else {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  })
                }
              })
            }
          }
        })
       
      },
      
    }
  }
</script>

<style scoped lang="scss">
  .body{
    padding: 30px;
    .title{
      padding: 20px 0;
      font-size: 18px;
      font-weight: bold;
    }
  }
  /deep/{
    .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .el-upload:hover {
        border-color: #409EFF;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
      }
      .avatar {
        width: 178px;
        height: 178px;
        display: block;
      }
  }
  
</style>